import * as designTokens from './typography';

export const typography = {
  ...designTokens,
};
